import axios, { type AxiosRequestConfig } from 'axios'
import { getMemberCalls2Url } from './http-helper'

const apiClient = axios.create({
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
})

export const proxiedGet = async <T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T> => {
    const response = await apiClient.get<T>(url, config)
    return response.data
}

export const proxiedPost = async <T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> => {
    const response = await apiClient.post<T>(url, data, config)
    return response.data
}

export const proxiedPut = async <T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> => {
    const response = await apiClient.put<T>(url, data, config)
    return response.data
}

export const directGet = async <T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T> => {
    const response = await axios.get<T>(url, config)
    return response.data
}

export const memberCalls2Get = async <T = unknown>(path: string, config?: AxiosRequestConfig): Promise<T> => {
    return proxiedGet<T>(getMemberCalls2Url(path), config)
}

export const memberCalls2Post = async <T = unknown>(path: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> => {
    return proxiedPost<T>(getMemberCalls2Url(path), data, config)
}

export { apiClient }
